// テンプレート選択モーダル管理
import { allTemplates, updateSelectedTemplate } from "./state.js";

// 一時的に選択されたテンプレート（モーダル内での選択状態）
let temporarySelectedTemplate = null;

// ページサイズを取得する関数
export const getCurrentPageSize = () => {
  const templateLayoutElement = document.getElementById("templateLayout");
  if (templateLayoutElement) {
    return templateLayoutElement.textContent.trim();
  }
  return "B5"; // デフォルト値
};

// ページサイズに応じてテンプレートをフィルタリングする関数
export const filterTemplatesByPageSize = (templates, pageSize) => {
  return templates.filter((template) => template.pageSize === pageSize);
};

// テンプレートカードのHTML要素を生成する関数
export const createTemplateCard = (template) => {
  const card = document.createElement("div");
  card.className = "template-card";
  card.dataset.templateId = template.templateId;

  const thumbnailPath = `/assets/album_templates/thumbnail/${template.templateId}.jpg`;

  card.innerHTML = `
    <div class="template-card-info">
      <h3 class="template-card-name">${template.name}</h3>
    </div>
    <div class="template-card-image">
      <img src="${thumbnailPath}" alt="${template.name}" loading="lazy" />
    </div>
  `;

  return card;
};

// テンプレート一覧を描画する関数
export const renderTemplateGrid = (pageSize) => {
  const gridContainer = document.getElementById("templateSelectionGrid");
  if (!gridContainer) {
    console.error("[renderTemplateGrid] テンプレートグリッドコンテナが見つかりません");
    return;
  }

  // 既存の内容をクリア
  gridContainer.innerHTML = "";

  // ページサイズに応じてテンプレートをフィルタリング
  const filteredTemplates = filterTemplatesByPageSize(allTemplates, pageSize);

  if (filteredTemplates.length === 0) {
    gridContainer.innerHTML = `
      <div class="template-grid-empty">
        <p>選択可能なテンプレートがありません。</p>
        <p>ページサイズ: ${pageSize}</p>
      </div>
    `;
    return;
  }

  console.log(`[renderTemplateGrid] ${pageSize}サイズのテンプレート ${filteredTemplates.length}件を表示`);

  // テンプレートカードを生成して追加
  filteredTemplates.forEach((template) => {
    const card = createTemplateCard(template);

    // クリックイベントを追加
    card.addEventListener("click", () => {
      handleTemplateCardClick(template);
    });

    gridContainer.appendChild(card);
  });
};

// テンプレートカードクリック時の処理（一時選択のみ）
export const handleTemplateCardClick = (template) => {
  console.log(`[handleTemplateCardClick] テンプレート一時選択: ${template.templateId} - ${template.name}`);

  // 一時的に選択されたテンプレートを保存
  temporarySelectedTemplate = template;

  // 既存の選択状態をクリア
  const allCards = document.querySelectorAll(".template-card");
  allCards.forEach((card) => {
    card.classList.remove("selected");
  });

  // クリックされたカードに選択状態を追加
  const clickedCard = document.querySelector(`[data-template-id="${template.templateId}"]`);
  if (clickedCard) {
    clickedCard.classList.add("selected");
  }

  // 決定ボタンを有効化
  const confirmButton = document.getElementById("templateSelectionConfirmButton");
  if (confirmButton) {
    confirmButton.disabled = false;
    //confirmButton.textContent = `「${template.name}」を決定する`;
  }

  console.log(`[handleTemplateCardClick] 一時選択完了: ${template.templateId}`);
};

// テンプレート選択を確定する処理
export const confirmTemplateSelection = () => {
  if (!temporarySelectedTemplate) {
    console.warn("[confirmTemplateSelection] 選択されたテンプレートがありません");
    return;
  }

  const template = temporarySelectedTemplate;
  console.log(`[confirmTemplateSelection] テンプレート選択確定: ${template.templateId} - ${template.name}`);

  // 1. 状態を更新
  updateSelectedTemplate(template.templateId);
  console.log(`[confirmTemplateSelection] 状態更新完了`);

  // 2. ボタンのテキストを更新
  const templatePreviewButton = document.getElementById("btn_template_preview");
  if (templatePreviewButton) {
    const oldText = templatePreviewButton.textContent;
    templatePreviewButton.textContent = template.name;
    console.log(`[confirmTemplateSelection] ボタンテキスト更新: "${oldText}" → "${template.name}"`);
  } else {
    console.error(`[confirmTemplateSelection] ボタン要素が見つかりません: btn_template_preview`);
  }

  // 3. セレクトボックスの値を更新
  const selectElement = document.getElementById("mase_case_entry_type_a1_itemStrVarchar02");
  if (selectElement) {
    const oldValue = selectElement.value;
    selectElement.value = template.templateId;
    console.log(`[confirmTemplateSelection] セレクトボックス更新: "${oldValue}" → "${template.templateId}"`);

    // 値が正しく設定されたかチェック
    if (selectElement.value === template.templateId) {
      console.log(`[confirmTemplateSelection] セレクトボックス値設定成功`);
    } else {
      console.error(`[confirmTemplateSelection] セレクトボックス値設定失敗: 期待値="${template.templateId}", 実際値="${selectElement.value}"`);

      // オプションが存在するかチェック
      const option = selectElement.querySelector(`option[value="${template.templateId}"]`);
      if (option) {
        console.log(`[confirmTemplateSelection] オプション存在確認: ${option.textContent}`);
        option.selected = true;
      } else {
        console.error(`[confirmTemplateSelection] オプションが存在しません: ${template.templateId}`);
        // 動的にオプションを追加
        const newOption = document.createElement("option");
        newOption.value = template.templateId;
        newOption.textContent = template.name;
        newOption.selected = true;
        selectElement.appendChild(newOption);
        console.log(`[confirmTemplateSelection] オプションを動的追加: ${template.templateId}`);
      }
    }

    // changeイベントを発火（既存の処理との互換性のため）
    const changeEvent = new Event("change", { bubbles: true });
    selectElement.dispatchEvent(changeEvent);
    console.log(`[confirmTemplateSelection] changeイベント発火完了`);
  } else {
    console.error(`[confirmTemplateSelection] セレクトボックス要素が見つかりません: mase_case_entry_type_a1_itemStrVarchar02`);
  }

  // 4. モーダルを閉じる
  hideTemplateSelectionModal();

  console.log(`[confirmTemplateSelection] テンプレート選択確定完了: ${template.templateId}`);
};

// テンプレート選択をキャンセルする処理
export const cancelTemplateSelection = () => {
  console.log("[cancelTemplateSelection] テンプレート選択をキャンセル");

  // 一時選択をクリア
  temporarySelectedTemplate = null;

  // モーダルを閉じる（セレクトボックスの変更なし）
  hideTemplateSelectionModal();
};

// テンプレート選択モーダルを表示する関数
export const showTemplateSelectionModal = () => {
  const modal = document.getElementById("templateSelectionModal");
  if (!modal) {
    console.error("[showTemplateSelectionModal] テンプレート選択モーダルが見つかりません");
    return;
  }

  // 一時選択をクリア
  temporarySelectedTemplate = null;

  // 現在のページサイズを取得
  const pageSize = getCurrentPageSize();
  console.log(`[showTemplateSelectionModal] ページサイズ: ${pageSize}`);

  // テンプレート一覧を描画
  renderTemplateGrid(pageSize);

  // 決定ボタンを初期状態に設定
  const confirmButton = document.getElementById("templateSelectionConfirmButton");
  if (confirmButton) {
    confirmButton.disabled = true;
    //confirmButton.textContent = "フレームを決定する";
  }

  // モーダルを表示
  modal.style.display = "flex";

  // ボディのスクロールを無効化（モーダル表示中）
  document.body.style.overflow = "hidden";
};

// テンプレート選択モーダルを非表示にする関数
export const hideTemplateSelectionModal = () => {
  const modal = document.getElementById("templateSelectionModal");
  if (modal) {
    modal.style.display = "none";
  }

  // 一時選択をクリア
  temporarySelectedTemplate = null;

  // ボディのスクロールを復元
  document.body.style.overflow = "";
};

// テンプレート選択モーダルのイベントリスナーを設定する関数
export const setupTemplateSelectionModal = () => {
  // 1. テンプレート選択ボタンのクリックイベント
  const templatePreviewButton = document.getElementById("btn_template_preview");
  if (templatePreviewButton) {
    templatePreviewButton.addEventListener("click", () => {
      console.log("[setupTemplateSelectionModal] テンプレート選択ボタンがクリックされました");
      showTemplateSelectionModal();
    });
  }

  // 2. モーダルの閉じるボタン（キャンセル処理）
  const closeButton = document.querySelector(".template-selection-close");
  if (closeButton) {
    closeButton.addEventListener("click", () => {
      console.log("[setupTemplateSelectionModal] 閉じるボタンがクリックされました（キャンセル）");
      cancelTemplateSelection();
    });
  }

  // 3. 確定ボタン
  const confirmButton = document.getElementById("templateSelectionConfirmButton");
  if (confirmButton) {
    confirmButton.addEventListener("click", () => {
      console.log("[setupTemplateSelectionModal] 確定ボタンがクリックされました");
      confirmTemplateSelection();
    });
  }

  // 4. モーダル背景クリックでキャンセル
  const modal = document.getElementById("templateSelectionModal");
  if (modal) {
    modal.addEventListener("click", (event) => {
      if (event.target === modal) {
        console.log("[setupTemplateSelectionModal] 背景クリックによるキャンセル");
        cancelTemplateSelection();
      }
    });
  }

  // 5. ESCキーでキャンセル
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      const modal = document.getElementById("templateSelectionModal");
      if (modal && modal.style.display !== "none") {
        console.log("[setupTemplateSelectionModal] ESCキーによるキャンセル");
        cancelTemplateSelection();
      }
    }
  });

  console.log("[setupTemplateSelectionModal] テンプレート選択モーダルのイベントリスナーを設定しました");
};

// 選択されたテンプレートの表示を更新する関数
export const updateSelectedTemplateDisplay = (templateId, templateName) => {
  const templatePreviewButton = document.getElementById("btn_template_preview");
  if (templatePreviewButton && templateName) {
    templatePreviewButton.textContent = templateName;
  } else if (templatePreviewButton) {
    templatePreviewButton.textContent = "フレームを選択する";
  }
};

// 初期化時に既存の選択状態を復元する関数
export const restoreSelectedTemplate = () => {
  console.log(`[restoreSelectedTemplate] 既存選択状態の復元を開始`);

  const selectElement = document.getElementById("mase_case_entry_type_a1_itemStrVarchar02");
  if (!selectElement) {
    console.error(`[restoreSelectedTemplate] セレクトボックス要素が見つかりません`);
    return;
  }

  console.log(`[restoreSelectedTemplate] セレクトボックスの現在値: "${selectElement.value}"`);

  if (selectElement.value) {
    const selectedTemplateId = selectElement.value;
    const selectedTemplate = allTemplates.find((t) => t.templateId === selectedTemplateId);

    if (selectedTemplate) {
      updateSelectedTemplate(selectedTemplateId);
      updateSelectedTemplateDisplay(selectedTemplateId, selectedTemplate.name);
      console.log(`[restoreSelectedTemplate] 既存の選択を復元: ${selectedTemplateId} - ${selectedTemplate.name}`);
    } else {
      console.warn(`[restoreSelectedTemplate] テンプレートが見つかりません: ${selectedTemplateId}`);
      console.log(
        `[restoreSelectedTemplate] 利用可能なテンプレート:`,
        allTemplates.map((t) => t.templateId)
      );
    }
  } else {
    console.log(`[restoreSelectedTemplate] 既存の選択はありません`);
  }
};

// デバッグ用：セレクトボックスの状態を確認する関数
export const debugSelectBoxState = () => {
  const selectElement = document.getElementById("mase_case_entry_type_a1_itemStrVarchar02");
  if (!selectElement) {
    console.error(`[debugSelectBoxState] セレクトボックス要素が見つかりません`);
    return;
  }

  console.group("[debugSelectBoxState] セレクトボックスの状態");
  console.log(`現在の値: "${selectElement.value}"`);
  console.log(`選択されたインデックス: ${selectElement.selectedIndex}`);
  console.log(`オプション数: ${selectElement.options.length}`);

  Array.from(selectElement.options).forEach((option, index) => {
    console.log(`オプション[${index}]: value="${option.value}", text="${option.textContent}", selected=${option.selected}`);
  });

  console.groupEnd();
};
